/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { FormSilverpopRequiredFields, FormTypes } from '@powdr/constants';

export const DiscountForm = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText = null,
  passthroughFunc,
  trackingTitle = null,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="pa-discount-form"
      title={trackingTitle}
      onSubmit={(e) => processForm(
        e,
        null,
        null,
        captchaRef,
        FormTypes.SILVERPOP,
        null,
        false,
      )}
    >

      <h2>Sign Up for Emails to Be Entered to Win a Free Week of Camp!</h2>

      <input name="CONTACT_LIST_ID" type="hidden" value="16908569" />

      <div className="flex-row mobile-stack">
        <div className="row-item">
          <input
            name="First Name"
            id="control_COLUMN3"
            className="form-control"
            type="text"
            placeholder="First Name *"
            required
          />
        </div>

        <div className="row-item">
          <input
            name="Last Name"
            id="control_COLUMN4"
            className="form-control"
            type="text"
            required
            placeholder="Last Name *"
          />
        </div>
      </div>

      <input
        className="form-control"
        type="text"
        name={FormSilverpopRequiredFields.EMAIL}
        id="control_EMAIL"
        label="Email Address"
        placeholder="Email Address"
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <div className="flex-row" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            passthroughFunc();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          value="Submit"
          disabled={!isUserVerified}
        >
          {buttonText || 'SUBMIT'}
        </button>
      </div>

      <small style={{ marginTop: '8px' }}>
        <a
          href="https://cms.woodwardpa.com/sites/default/files/2025-10/Powdr%20-%20Woodward%20Camp%20Giveaways%20-%20Terms%20%26%20Conditions.pdf"
          target="_blank"
          rel="noreferrer"
        >
          See Terms & Conditions
        </a>
      </small>
    </form>
  );
};

DiscountForm.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  passthroughFunc: PropTypes.func.isRequired,
  trackingTitle: PropTypes.string,
};
